// extracted by mini-css-extract-plugin
export default {"chatBox":"ChatBox_chatBox__q3Kwx","chatBoxArrow":"ChatBox_chatBoxArrow__HEQcB","chatBoxQuestion":"ChatBox_chatBoxQuestion__OVzYB"};